import store from '../store'

const hasRole = (roleNumber) => {
  return store.state.auth.user.roles.indexOf(roleNumber) >= 0
}

export const roles = {
  ADMIN: 'Admin',
  OPERATOR: 'Operator',
  ENVIAR_COMANDO: 'EnviarComando',
  ENVIAR_SMS_COMANDO: 'EnviarSmsComando',
  EPANET: 'Epanet',
  GUEST: 'Guest',
  VIEW: 'View',
  VIEW_VISUALIZAR: 'ViewVisualizar',
  CARGOS: 'Cargos',
  ENVIAR_DADOS_SIG: 'EnviarDadosSIG',
  ETA_OPERADOR: 'EtaOperador',
  ETA_RELATORIO: 'EtaRelatorio',
  EPANET_EDICAO: 'EpanetEdicao',
  EQUIPAMENTO_CRIAR: 'EquipamentoCriar',
  EQUIPAMENTO_EDITAR: 'EquipamentoEditar',
  NOTIFICACAO: 'Notificacao',
  CMD_AUTO_EDICAO: 'CmdAutoEdicao',
  CALIBRACAO_EDICAO: 'CalibracaoEdicao',
  MAPA_VISUALIZAR: 'MapaVisualizar',
  MAPA_EDICAO: 'MapaEdicao',
}

const auth = {
  hasRole,
  isAdmin() {
    return hasRole(roles.ADMIN)
  },
  canEpanet() {
    return this.isAdmin() || hasRole(roles.EPANET)
  },
  isOperator() {
    return this.isAdmin() || hasRole(roles.OPERATOR)
  },
  canSendAction() {
    return hasRole(roles.ADMIN) || hasRole(roles.ENVIAR_COMANDO)
  },
  canSendSmsAction() {
    return hasRole(roles.ADMIN) || hasRole(roles.ENVIAR_SMS_COMANDO)
  },
  canCargos() {
    return this.isAdmin() || hasRole(roles.CARGOS)
  },
  canView() {
    return this.isAdmin() || hasRole(roles.VIEW)
  },
  canViewVisualizar() {
    return (
      this.isAdmin() || hasRole(roles.VIEW) || hasRole(roles.VIEW_VISUALIZAR)
    )
  },
  canSig() {
    return this.isAdmin() || hasRole(roles.ENVIAR_DADOS_SIG)
  },
  canEta() {
    return (
      this.isAdmin() ||
      hasRole(roles.ETA_OPERADOR) ||
      hasRole(roles.ETA_RELATORIO)
    )
  },
  canEpanetEdicao() {
    return this.isAdmin() || hasRole(roles.EPANET_EDICAO)
  },
  canEquipamentoCriar() {
    return this.isAdmin() || hasRole(roles.EQUIPAMENTO_CRIAR)
  },
  canEquipamentoEditar() {
    return this.isAdmin() || hasRole(roles.EQUIPAMENTO_EDITAR)
  },
  canNotificacoes() {
    return this.isAdmin() || hasRole(roles.NOTIFICACAO)
  },
  canCmdAuto() {
    return (
      this.isAdmin() ||
      hasRole(roles.EQUIPAMENTO_EDITAR) ||
      hasRole(roles.CMD_AUTO_EDICAO)
    )
  },
  canCalibracao() {
    return (
      this.isAdmin() ||
      hasRole(roles.EQUIPAMENTO_EDITAR) ||
      hasRole(roles.CALIBRACAO_EDICAO)
    )
  },
  canViewMapa() {
    return (
      this.isAdmin() ||
      hasRole(roles.MAPA_VISUALIZAR) ||
      hasRole(roles.MAPA_EDICAO)
    )
  },
  canEditMapa() {
    return this.isAdmin() || hasRole(roles.MAPA_EDICAO)
  },
}

export function roleToText(role) {
  switch (role) {
    case roles.ADMIN:
      return 'Administrador'
    case roles.OPERATOR:
      return 'Operador'
    case roles.ENVIAR_COMANDO:
      return 'Enviar Comando'
    case roles.ENVIAR_SMS_COMANDO:
      return 'Enviar SMS Comando'
    case roles.EPANET:
      return 'Modulo EPANET'
    case roles.GUEST:
      return 'Convidado'
    case roles.VIEW:
      return 'SCADA Edição'
    case roles.VIEW_VISUALIZAR:
      return 'SCADA Visualizar'
    case roles.CARGOS:
      return 'Cargos'
    case roles.ENVIAR_DADOS_SIG:
      return 'Enviar Dados SIG'
    case roles.ETA_OPERADOR:
      return 'Operador ETA'
    case roles.ETA_RELATORIO:
      return 'Baixar Relatório ETA'
    case roles.EPANET_EDICAO:
      return 'Epanet Edição'
    case roles.EQUIPAMENTO_EDITAR:
      return 'Editar equipamento'
    case roles.EQUIPAMENTO_CRIAR:
      return 'Criar equipamento'
    case roles.NOTIFICACAO:
      return 'Notificação'
    case roles.CMD_AUTO_EDICAO:
      return 'CMD Auto Edição'
    case roles.CALIBRACAO_EDICAO:
      return 'Calibração Edição'
    case roles.MAPA_VISUALIZAR:
      return 'Mapa Visualizar'
    case roles.MAPA_EDICAO:
      return 'Mapa Edição'
    default:
      return role
  }
}

export default auth
